import React from 'react';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';
import TodayIcon from '@mui/icons-material/Today';
import DateRangeIcon from '@mui/icons-material/DateRange';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { PeriodEnum } from '../../types/Report.type';
import { useTranslation } from '../../i18n';

interface PeriodSelectorProps {
  period: PeriodEnum;
  onChange: (period: PeriodEnum) => void;
}

const PeriodSelector: React.FC<PeriodSelectorProps> = ({
  period,
  onChange,
}) => {
  const { t } = useTranslation();

  const handleChange = (
    _event: React.MouseEvent<HTMLElement>,
    newPeriod: PeriodEnum,
  ) => {
    if (newPeriod !== null) {
      onChange(newPeriod);
    }
  };

  return (
    <ToggleButtonGroup
      value={period}
      exclusive
      onChange={handleChange}
      aria-label="time period"
      sx={{
        mb: 2,
        '& .MuiToggleButton-root': {
          textTransform: 'capitalize',
          px: 3,
          py: 1,
          fontSize: '0.875rem',
          borderRadius: 1,
          '&.Mui-selected': {
            fontWeight: 'medium',
          },
        },
      }}
    >
      <ToggleButton value={PeriodEnum.DAILY} aria-label="daily" sx={{ mr: 2 }}>
        <TodayIcon fontSize="small" sx={{ mr: 1 }} />
        {t('report.daily')}
      </ToggleButton>
      <ToggleButton
        value={PeriodEnum.WEEKLY}
        aria-label="weekly"
        sx={{ mr: 2 }}
      >
        <DateRangeIcon fontSize="small" sx={{ mr: 1 }} />
        {t('report.weekly')}
      </ToggleButton>
      <ToggleButton value={PeriodEnum.MONTHLY} aria-label="monthly">
        <CalendarMonthIcon fontSize="small" sx={{ mr: 1 }} />
        {t('report.monthly')}
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default PeriodSelector;
